module.exports = __webpack_public_path__ + "img/49.282697ec.jpg";